export const imgsUrl = `https://api.fusion.usign.io/files/`

export const hookUrl = `https://webhooks.fusion.usign.io/5f4951c495c967001339efa4/`

export const mediaCache = 'media-btp-cache'

/**
 * IMPORTANT: REMEMBER TO CHECK THE FILE SW.JS ABOUT THE PATHS AND CACHE NAMES
 */
